import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf, NgFor, DatePipe } from '@angular/common';

import { News, NewsContent } from '../../models/news-model';
import { LocationService } from '../../services/location.service';
import { NewsService } from '../../services/news.service';
import { TranslationService } from '../../services/translation.service';
import { UNDERSCORE } from '../utils/constants';
import { LoadingSpinnerComponent } from '../utils/loading-spinner.component';
import { OfflineComponent } from '../offline/offline.component';

@Component({
	selector: 'copo-news-card',
	templateUrl: './news-card.component.html',
	styleUrl: './news-card.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, MatButtonModule, MatIconModule, NgFor, OfflineComponent, LoadingSpinnerComponent, DatePipe]
})
export class NewsCardComponent implements OnDestroy {
	readonly UNDERSCORE = UNDERSCORE;
	newsId: number;
	news?: News;
	newsCard: NewsContent | undefined;
	isLoading = false;
	isOffline = false;
	fileUrls = new WeakMap<File, string>();
	newsFields = <const> [
		'id',
		'type',
		'from',
		'to',
		'audiences.members',
		'newsContents',
		'newsContents.newsAttachments',
		'services',
		'audiences',
		'rowCreationBy',
		'rowCreationDate'
	];

	newsSub?: Subscription;
	constructor(
		private readonly newsService: NewsService,
		private readonly translationService: TranslationService,
		private readonly location: LocationService,
		readonly route: ActivatedRoute
	) {
		this.newsId = Number(this.route.snapshot.params['cardId']);
		this.isOffline = !navigator.onLine;
		this.isLoading = true;
		this.getNewsDetails();
	}

	getNewsDetails() {
		this.newsSub = this.newsService.getNewsById(this.newsId, this.newsFields).subscribe({
			next: value => {
				this.news = value;
				this.news.contents[0].content = this.convertNewsContentToHTML(this.news.contents[0].content);
				this.newsCard = this.news.contents.find(
					({ languageCode }) => languageCode === this.translationService.currentLanguage
				);
				if (!this.newsCard) {
					this.newsCard = this.news.contents.find(({ languageCode }) => languageCode === 'en');
				}
				this.isLoading = false;
			},
			error: (err: unknown) => {
				console.error('error loading', err);
				this.isLoading = false;
			}
		});
	}

	getDocumentURL(id: number, name: string) {
		return this.newsService.getViewDocumentUrl(id, name);
	}

	back() {
		this.location.back();
	}

	ngOnDestroy() {
		if (this.newsSub) {
			this.newsSub.unsubscribe();
		}
	}

	convertNewsContentToHTML(text: string): string {
		const urlPattern = /(https?:\/\/\S+)/g;
		// eslint-disable-next-line sonarjs/slow-regex
		const emailPattern = /([\w.-]+@[\w.-]+\.[\w-]+)/g;
		return text.replace(urlPattern, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
			.replace(emailPattern, '<a href="mailto:$1">$1</a>');
	}
}
